import { Component, OnInit } from '@angular/core';

import { environment } from '@environments/environment';

import { Loading } from '@app/shared/models';
import { CensoService } from '@app/shared/services/censo.service';

@Component({
  selector: 'app-documentacao',
  templateUrl: './documentacao.component.html',
  styleUrls: ['./documentacao.component.scss']
})
export class DocumentacaoComponent implements OnInit {
  carregar = new Loading();

  cliente = environment.cliente;
  content: any;

  constructor(
    private censoService: CensoService
    ) { }

  ngOnInit(): void {
    this.buscarTexto();
  }

  buscarTexto(): void {
    this.censoService.buscarTexto(this.cliente.censo_id, 'documentacao', this.carregar).subscribe(texto => {
      this.content = texto;
    })
  }
}
